<template>
  <b-overlay
    :show="loading"
    rounded="sm"
  >
    <div
      v-if="Form.OrderPayment"
      class="mb-1 d-flex flex-column flex-md-row justify-content-between align-items-start align-items-md-center mb-6 row-gap-4"
    >

      <div class="d-flex flex-column justify-content-center">
        <div class="mb-1">
          <span style="font-size: 16px; font-weight: 600;">سفارش #{{ Form.Id }} </span>
          <template v-if="Form.OrderPayment.length">
            <b-badge
              v-if="Form.OrderPayment[0].IsPaid"
              variant="light-success"
            >
              پرداخت شده
            </b-badge>
            <b-badge
              v-else
              variant="light-warning"
            >
              پرداخت نشده
            </b-badge>
          </template>

          <b-badge
            v-if="Form.Status !== null"
            class="ml-1"
            :variant="'light-'+enums('OrderStatus', 'value', Form.Status, 'badge')"
            @click="openSidebar(data.item)"
          >
            {{ enums('OrderStatus', 'value', Form.Status, 'text') }}
          </b-badge>
        </div>
        <p
          v-if="Form.OrderPayment.length"
          class="mb-0"
        >
          {{ Form.OrderPayment[0].CreatedAt | date('jDD jMMMM jYYYY، ساعت HH:mm') }}
        </p>
        <p
          v-else-if="Form.OrderAddress"
          class="mb-0"
        >
          {{ Form.OrderAddress.CreatedAt | date('jDD jMMMM jYYYY، ساعت HH:mm') }}
        </p>
      </div>
      <b-button
        v-if="Form.Status == 0"
        v-ripple.400="'rgba(186, 191, 199, 0.15)'"
        variant="primary"
        @click="changeStatus(1)"
      >تایید سفارش
      </b-button>
      <b-dropdown
          v-else-if="Form.Status != null"
          variant="outline-primary"
          :text="enums('OrderStatus', 'value', Form.Status, 'text') "
          class="status-dropdown"
          left
          no-flip
      >
        <b-dropdown-item
            v-for="status in enums('OrderStatus')"
            :key="status.value"
            @click="changeStatus(status.value)"
            :class="{'active': Form.Status === status.value}"
        >
          <span class="status-indicator" :class="'status-' + status.value"></span>
          {{ status.text }}
        </b-dropdown-item>
      </b-dropdown>
    </div>
    <b-row v-if="Form.OrderDetails">
      <b-col md="8">
        <b-card title="سبد خرید">
          <b-row>
            <b-col>
              <b-table
                bordered
                hover
                striped
                :items="Form.OrderDetails"
                :fields="fields"
                class="mt-1 mb-2 position-relative"
                responsive
                :busy="loading"
              >
                <template #cell(Id)="data">
                  <b-link
                    :to="{ name: 'updateproductcolor', params: { id: data.value }, query:{ productid: $route.params.id }}"
                    class="font-weight-bold"
                  >
                    #{{ data.value }}
                  </b-link>
                </template>

                <template #cell(Product)="data">
                  <b-link :to="{ name: 'updateproduct', params: { id: data.value.Id }}">
                    <b-media
                      vertical-align="center"
                      style="align-items: center;"
                    >
                      <template #aside>
                        <b-avatar
                          :src="data.value.Image"
                        />
                      </template>
                      <span
                        class="font-weight-bold d-block"
                        style="color: #6e6b7b;"
                      >
                        {{ data.value.Title }}
                        <template v-if="data.value.ProductVariety">
                          <span
                            v-for="(item, index) in data.value.ProductVariety.ProductVarietyAttribute"
                            style="opacity: 0.7; font-size: 85%; display: block;"
                          >
                            {{ item.ProductAttribute.Title }}: {{ item.Title }}
                          </span>
                        </template>

                      </span>
                      <!--                                          <small class="text-muted">{{ data.value.Id }}</small>-->
                    </b-media>
                  </b-link>
                </template>

                <template #cell(Price)="data">
                  {{ data.value | price }}
                </template>

                <template #cell(Discount)="data">
                  {{ data.value | price }}
                </template>

                <template #cell(Quantity)="data">
                  {{ data.value | price }}
                </template>

                <template #cell(PackagingPrice)="data">
                  {{ data.value | price }}
                </template>

              </b-table>

              <div class="d-flex justify-content-end align-items-center m-6 mb-2">
                <div class="order-calculations">
                  <div class="d-flex justify-content-start mb-2">
                    <span class="w-px-120 text-heading">مبلغ کالاها:</span>
                    <h6
                      class="mb-0"
                      style="font-weight: 600;"
                    >
                      {{ Form.ProductPrice | price }} تومان
                    </h6>
                  </div>
                  <div class="d-flex justify-content-start mb-2">
                    <span class="w-px-120 text-heading">تخفیف کالاها:</span>
                    <h6
                      class="mb-0"
                      style="font-weight: 600;"
                    >
                      {{ Form.Discount | price }} تومان
                    </h6>
                  </div>
                  <div class="d-flex justify-content-start mb-2">
                    <span class="w-px-120 text-heading">کد تخفیف:</span>
                    <h6
                      class="mb-0"
                      style="font-weight: 600;"
                    >
                      <template v-if="Form.OrderCoupon">
                        {{ Form.OrderCoupon.Price | price }} تومان
                      </template>
                      <template v-else>
                        0 تومان
                      </template>
                    </h6>
                  </div>
                  <div class="d-flex justify-content-start mb-2">
                    <span class="w-px-120 text-heading">هزینه ارسال:</span>
                    <h6
                        class="mb-0"
                        style="font-weight: 600;"
                    >
                      {{ Form.ShippingPrice | price }} تومان
                    </h6>
                  </div>
                  <div class="d-flex justify-content-start mb-2">
                    <span class="w-px-120 text-heading">هزینه بسته بندی:</span>
                    <h6
                      class="mb-0"
                      style="font-weight: 600;"
                    >
                      {{ Form.PackagingPrice | price }} تومان
                    </h6>
                  </div>
                  <div class="d-flex justify-content-start">
                    <h6 class="w-px-120 mb-0">
                      مبلغ پرداختی:
                    </h6>
                    <h6
                      class="mb-0"
                      style="font-weight: 600;"
                    >
                      {{ Form.PayPrice | price }} تومان
                    </h6>
                  </div>
                </div>
              </div>
            </b-col>

          </b-row>
        </b-card>

        <b-card
          v-if="Form.OrderDetails[0].OrderDetailsQuestion.length"
          title="جزئیات سفارش"
        >
          <div
            v-for="item in Form.OrderDetails[0].OrderDetailsQuestion"
            class="mb-3"
          >
            <h5>
              {{ item.ProductQuestion.Title }}
            </h5>
            <p
              v-if="item.Description"
              class="mb-1"
            >
              {{ item.Description }}
            </p>
            <p
              v-for="op in item.OrderDetailsQuestionOption"
              v-else-if="item.OrderDetailsQuestionOption.length"
              class="mb-1"
            >
              {{ op.DutyQuestionOption.Title }}
            </p>
            <p
              v-for="at in item.OrderDetailsQuestionAttachment"
              v-else-if="item.OrderDetailsQuestionAttachment.length"
              class="mb-1"
            >
              <a
                target="_blank"
                :href="at.Url"
              >{{ at.Url }}</a>
            </p>
            <p
              v-else
              class="mb-1"
            >
              -
            </p>
          </div>
        </b-card>
      </b-col>
      <b-col md="4">
        <b-card
          v-if="Form.User"
          title="اطلاعات مشتری"
        >
          <div>
            <b-link>
              <b-media
                vertical-align="center"
                style="align-items: center;"
              >
                <template #aside>
                  <b-avatar
                    :src="Form.User.Image"
                  />
                </template>
                <span
                  class="font-weight-bold d-block text-nowrap"
                  style="color: #6e6b7b;"
                >
                  {{ Form.User.Name }} {{ Form.User.Family }}
                </span>
                <small class="text-muted">{{ Form.User.Mobile }}</small>
              </b-media>
            </b-link>
          </div>
          <div class="mt-1 mb-1">
            <b-avatar
              variant="light-success"
              class="mr-1"
            >
              <feather-icon
                class="cursor-pointer"
                icon="ShoppingCartIcon"
              />
            </b-avatar>
            <span>{{ Form.User.Order.length }} سفارش</span>
          </div>
        </b-card>
        <b-card title="اطلاعات ارسال">
          <div>
            <h5>نام و نام خانوادگی</h5>
            <p
              v-if="Form.OrderAddress"
              class="mb-1"
            >
              {{ Form.OrderAddress.Name }} {{ Form.OrderAddress.Family }}
            </p>
            <p
              v-else
              class="mb-1"
            >
              -
            </p>
          </div>
          <div>
            <h5>استان، شهر</h5>
            <p
              v-if="Form.OrderAddress && Form.OrderAddress.City"
              class="mb-1"
            >
              {{ Form.OrderAddress.City.State.Title }}، {{ Form.OrderAddress.City.Title }}
            </p>
            <p
              v-else
              class="mb-1"
            >
              -
            </p>
          </div>
          <div>
            <h5>آدرس</h5>
            <p
              v-if="Form.OrderAddress"
              class="mb-1"
            >
              {{ Form.OrderAddress.Address ? Form.OrderAddress.Address: "-" }}
            </p>
            <p
              v-else
              class="mb-1"
            >
              -
            </p>
          </div>
          <div>
            <h5>کد پستی</h5>
            <p
              v-if="Form.OrderAddress"
              class="mb-1"
            >
              {{ Form.OrderAddress.PostalCode ? Form.OrderAddress.PostalCode:"-" }}
            </p>
            <p
              v-else
              class="mb-1"
            >
              -
            </p>
          </div>
          <div>
            <h5>موبایل</h5>
            <p
              v-if="Form.OrderAddress"
              class="mb-1"
            >
              {{ Form.OrderAddress.Mobile }}
            </p>
            <p
              v-else
              class="mb-1"
            >
              -
            </p>
          </div>
          <div>
            <h5>تلفن ثابت</h5>
            <p
              v-if="Form.OrderAddress"
              class="mb-1"
            >
              {{ Form.OrderAddress.PhoneCode }}-{{ Form.OrderAddress.Phone }}
            </p>
            <p
              v-else
              class="mb-1"
            >
              -
            </p>
          </div>
          <div>
            <h5>توضیحات</h5>
            <p
              v-if="Form.OrderAddress"
              class="mb-1"
            >
              {{ Form.OrderAddress.Description ? Form.OrderAddress.Description: "-" }}
            </p>
            <p
              v-else
              class="mb-1"
            >
              -
            </p>
          </div>

          <div class="mt-2">
            <h5 style="display: flex; justify-content: space-between;">
              <span>کد رهگیری</span>
              <a
                style="color: #7367f0;"
                @click="showPostalTrackingCodeModal()"
              >ویرایش</a>
            </h5>
            <p class="mb-1">
              {{ Form.PostalTrackingCode ? Form.PostalTrackingCode : '-' }}
            </p>
          </div>
        </b-card>
      </b-col>

    </b-row>

    <b-modal
      v-if="showModal"
      v-model="showModal"
      ok-title="ذخیره"
      cancel-title="انصراف"
      cancel-variant="outline-secondary"
      centered
      title="ویرایش"
      :no-close-on-backdrop="true"
      size="sm"
      @ok="savePostalTrackingCode"
    >
      <b-row>
        <b-col md="12">
          <b-form-group
            label="کدرهگیری"
            label-for="Title"
          >
            <b-form-input
              id="Title"
              v-model="postalTrackingCode"
              autocomplete="off"
            />
          </b-form-group>
        </b-col>
      </b-row>

    </b-modal>
  </b-overlay>
</template>

<script>

import ProductCategory from '@/tools/productcategory.vue'

export default {
  name: 'OrderDetails',
  components: { ProductCategory },
  data() {
    return {
      Form: {
        Id: null,
      },
      loading: false,
      showModal: false,
      PostalTrackingCode: null,
      fields: [
        {
          key: 'Id',
          label: '#',
          thClass: 'col-width-50',
        },
        {
          key: 'Product',
          label: 'عنوان',
        },
        {
          key: 'Price',
          label: 'مبلغ',
        },
        {
          key: 'Discount',
          label: 'تخفیف',
        },
        {
          key: 'PackagingPrice',
          label: 'هزینه بسته بندی',
        },
        {
          key: 'Quantity',
          label: 'تعداد',
        },
      ],
    }
  },
  created() {
    if (this.$route.params.id) {
      this.Form.Id = this.$route.params.id
      this.get()
    }
  },
  methods: {
    save() {
      let url = this.$api.productcategory.add
      if (this.$route.params.id) {
        url = this.$api.productcategory.update
      }

      console.log(this.$refs.productcategoryform)

      const formData = new FormData(this.$refs.productcategoryform)
      formData.append('Id', this.Form.Id)
      formData.append('Description', this.Form.Description)
      formData.append('SliderSortBy', this.Form.SliderSortBy)

      if (this.Form.ProductCategoryId) {
        formData.append('ProductCategoryId', this.Form.ProductCategoryId)
      }

      this.loading = true
      this.$http.post(
        url, formData,
      )
        .then(() => {
          this.back()
        })
        .finally(() => {
          this.loading = false
        })
    },
    imageRenderer(event) {
      const fileReader = new FileReader()
      fileReader.readAsDataURL(event.target.files[0])

      fileReader.onload = () => {
        this.Form.Image = fileReader.result
      }
    },
    sliderImageRenderer(event) {
      const fileReader = new FileReader()
      fileReader.readAsDataURL(event.target.files[0])

      fileReader.onload = () => {
        this.Form.SliderImage = fileReader.result
      }
    },
    get() {
      this.loading = true
      this.$http.post(
        this.$api.order.get, {
          Id: this.Form.Id,
        },
      )
        .then(res => {
          this.loading = false
          this.Form = res.data
        })
    },
    changeStatus(status) {
      this.loading = true
      this.$http.post(
        this.$api.order.changestatus, {
          Id: this.Form.Id,
          Status: status,
        },
      )
        .then(res => {
          this.get()
        })
    },
    savePostalTrackingCode() {
      this.loading = true
      this.$http.post(
        this.$api.order.updatepostaltrackingcode, {
          Id: this.Form.Id,
          PostalTrackingCode: this.postalTrackingCode,
        },
      )
        .then(res => {
          this.get()
        })
    },
    showPostalTrackingCodeModal() {
      this.postalTrackingCode = this.Form.PostalTrackingCode
      this.showModal = true
    },
  },
}
</script>

<style scoped>

.w-px-120 {
  width: 120px !important;
}
h5{
  font-weight: 600;
  font-size: 14px !important;
}

</style>
